import React from 'react';
import "./Loading.css"
const Loading = () => (
    <div className="spinner">
        <div className="cssload-container">
            <div className="cssload-item cssload-ventilator"/>
        </div>
    </div>
);
export default Loading